export const Failed_Load = 'Failed_Load';
export const Push_SEOMonitor_Data = 'Push_SEOMonitor_Data';
export const Get_SEOMonitor_Data = 'Get_SEOMonitor_Data';
export const Clear_Google_Sheet_Data = 'Clear_Google_Sheet_Data';
